import { gsap } from "gsap";


const searchPopUp = {
    init() {
        let self = this;
        self.popUpNode = document.querySelector('.js-search-popup');

        if(! self.popUpNode && ! document.querySelector('.js-search-button')) {
            return;
        }

        self.createListeners();
    },

    createListeners() {
        let self = this;
        
        if(document.querySelector('.js-search-popup').dataset.initialized === true) {
            return;
        }


        let closeButton = document.querySelector('.js-search-bar-close-button')
        let openButtons = document.querySelectorAll('.js-search-button');

        closeButton.addEventListener('click', function() {
            self.closeSearchBarPopUp();
        });

        openButtons.forEach(button => {
            button.addEventListener('click', function() {
                self.openSearchBarPopUp();
            });
        });

        document.querySelector('.js-search-popup').dataset.initialized = true;
        
    },


    openSearchBarPopUp() {
        document.querySelector('.js-search-popup').classList.remove('hidden');
        window.navMenu.closeMenu();
        gsap.from('.js-search-popup', {autoAlpha: 0, duration: 0.3});
        gsap.from('.js-search-popup > div', {autoAlpha: 0, duration: 0.3, y: -50});
    },

    closeSearchBarPopUp() {

        let popUpNode = document.querySelector('.js-search-popup');
        gsap.to('.js-search-popup', {autoAlpha: 0, duration: 0.3, delay: 0.1, onComplete:function(){
            popUpNode.removeAttribute('style');
            popUpNode.classList.add('hidden');
        }});
    }
};

window.searchPopUp = searchPopUp;

searchPopUp.init();

document.addEventListener('LokiRequestEnd', function () {
    searchPopUp.init();
});
